//import {LngLat, LngLatBounds, YMap} from '@yandex/ymaps3-types';

export const INFO_MESSAGE_TEXT = 'Select the instrument and draw on a map';
export const DRAW_BUTTON_TEXT = 'Pencil selection';

export const POLYGON_OPTIONS = {
    cursor: 'pointer',
    stroke: [{width: 3, color: '#2E4CE599'}],
    fill: '#122DB21A'
};

export const BOUNDING_BOX_OPTIONS = {
    stroke: [{width: 1, color: '#122DB2'}],
    fillOpacity: 0
};

export const CANVAS_OPTIONS = {
    strokeStyle: '#2E4CE599',
    lineWidth: 4,
    opacity: '0.7'
};

export function drawLineOverMap(map) {
    const canvas = document.querySelector('#draw-canvas');
    const ctx2d = canvas.getContext('2d');
    let drawing = false;
    let coordinates = [];

    const rect = map.container;
    canvas.style.width = rect.offsetWidth + 'px';
    canvas.style.height = rect.offsetHeight + 'px';
    canvas.width = rect.offsetWidth;
    canvas.height = rect.offsetHeight;

    ctx2d.strokeStyle = CANVAS_OPTIONS.strokeStyle;
    ctx2d.lineWidth = CANVAS_OPTIONS.lineWidth;
    canvas.style.opacity = CANVAS_OPTIONS.opacity;

    ctx2d.clearRect(0, 0, canvas.width, canvas.height);

    canvas.style.display = 'block';

    canvas.onmousedown = function (e) {
        drawing = true;
        coordinates.push([e.offsetX, e.offsetY]);
    };

    canvas.onmousemove = function (e) {
        if (drawing) {
            const last = coordinates[coordinates.length - 1];
            ctx2d.beginPath();
            ctx2d.moveTo(last[0], last[1]);
            ctx2d.lineTo(e.offsetX, e.offsetY);
            ctx2d.stroke();
            coordinates.push([e.offsetX, e.offsetY]);
        }
    };

    return new Promise(function (resolve) {
        canvas.onmouseup = function (e) {
            coordinates.push([e.offsetX, e.offsetY]);
            canvas.style.display = 'none';
            drawing = false;

            coordinates = coordinates.map((x) => [
                x[0] / canvas.width,
                x[1] / canvas.height
            ]);

            resolve(coordinates);
        };
    });
}

export const getBoundingBox = (points) => {
    let minLongitude = points[0][0];
    let maxLongitude = points[0][0];
    let minLatitude = points[0][1];
    let maxLatitude = points[0][1];

    points.forEach(([longitude, latitude]) => {
        if (longitude < minLongitude) minLongitude = longitude;
        if (longitude > maxLongitude) maxLongitude = longitude;
        if (latitude < minLatitude) minLatitude = latitude;
        if (latitude > maxLatitude) maxLatitude = latitude;
    });

    const bottomLeft = [minLongitude, minLatitude];
    const bottomRight = [maxLongitude, minLatitude];
    const topLeft = [minLongitude, maxLatitude];
    const topRight = [maxLongitude, maxLatitude];

    return [bottomLeft, bottomRight, topRight, topLeft];
};

export const transformCoordinates = (bounds, coordinates) => {
    return coordinates
        .map((x) => [
            bounds[0][0] + x[0] * (bounds[1][0] - bounds[0][0]),
            bounds[0][1] + x[1] * (bounds[1][1] - bounds[0][1])
        ])
        .filter((_, index) => index % 5 === 0);
};

// Экспортируемые переменные
export let InfoMessage = null;
export let DrawButton = null;

// Функция инициализации контролов. Вызывать только после загрузки API Yandex Maps.
export function initControls() {
    if (typeof ymaps3 !== 'undefined' && ymaps3.ready) {
        ymaps3.ready.then(() => {
            class InfoMessageClass extends ymaps3.YMapComplexEntity {
                _element;
                _detachDom;

                _createElement(props) {
                    const infoWindow = document.createElement('div');
                    infoWindow.classList.add('info-window');
                    infoWindow.innerText = props.text;
                    return infoWindow;
                }

                _onAttach() {
                    this._element = this._createElement(this._props);
                    this._detachDom = ymaps3.useDomContext(this, this._element, this._element);
                }

                _onDetach() {
                    this._detachDom();
                    this._detachDom = undefined;
                    this._element = undefined;
                }
            }

            class DrawButtonClass extends ymaps3.YMapComplexEntity {
                _element;
                _detachDom;

                _createElement(props) {
                    const drawButton = document.createElement('button');
                    drawButton.className = 'draw-button';
                    drawButton.id = 'draw-button';
                    drawButton.innerText = props.text;
                    drawButton.onclick = props.onClick;
                    return drawButton;
                }

                _onAttach() {
                    this._element = this._createElement(this._props);
                    this._detachDom = ymaps3.useDomContext(this, this._element, this._element);
                }

                _onDetach() {
                    this._detachDom();
                    this._detachDom = undefined;
                    this._element = undefined;
                }
            }

            InfoMessage = InfoMessageClass;
            DrawButton = DrawButtonClass;
        });
    } else {
        console.warn('Yandex Maps API (ymaps3) is not loaded yet. Cannot initialize controls.');
    }
}
